// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel_root__19UEV","title":"Panel_title__2POlm","text":"Panel_text__36BBe","list":"Panel_list__3NqOE","notice":"Panel_notice__1KWrs"};